import React from "react";
import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const Residence: React.FC = () => {
  const { formData, updateFormData } = useOutletContext<FormContext>();

  return (
    <FormProvider {...formData}>
      <FormSection title={t("security-clearance.visitor-particulars-of-residence")}>
        <FormItem<PortSecurityFormData, "zone">
          name="zone"
          type="text"
          maxChars={200}
          label={t("security-clearance.zone")}
          testId="security-zone"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "ownerName">
          name="ownerName"
          type="text"
          maxChars={200}
          label={t("security-clearance.owner-name")}
          testId="security-ownerName"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "phoneNo">
          name="phoneNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.phone-no")}
          testId="security-phoneNo"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "street">
          name="street"
          type="text"
          maxChars={200}
          label={t("security-clearance.street")}
          testId="security-street"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "mobileNo">
          name="mobileNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.mobile-no")}
          testId="security-mobileNo"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "buildingNo">
          name="buildingNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.building-no")}
          testId="security-buildingNo"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "pagerNo">
          name="pagerNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.pager-no")}
          testId="security-pagerNo"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "flatNo">
          name="flatNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.flat-no")}
          testId="security-flatNo"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "poBoxNo">
          name="poBoxNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.po-box-no")}
          testId="security-poBoxNo"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "floorNo">
          name="floorNo"
          type="text"
          maxChars={200}
          label={t("security-clearance.floor-no")}
          testId="security-floorNo"
          onFieldChange={updateFormData}
        />
      </FormSection>
    </FormProvider>
  );
};

export default Residence;
